import generated from './mockRegistrations.generated.json';

export type MockRegistration = {
  id: string;
  displayName: string;
  message: string;
  photoUrl: string;
  country: string;
  createdAt: string;
  verificationCode: string;
};

export const mockRegistrations: MockRegistration[] = generated as MockRegistration[];
